module.exports = __webpack_public_path__ + "static/media/logo_esn_small_nl.e44a7611.svg";